export const getGraphqlURI = () => {
  // This application makes server-side and client-side calls to Hasura.
  // In dev, we need to use a different hostname for server-side requests.
  // This function helps us assign the correct hostname to each request.
  const isServer = typeof window === "undefined" ? true : false;
  if (isServer) return process.env.GRAPHQL_SERVERSIDE_URI as string;

  return process.env.NEXT_PUBLIC_GRAPHQL_URI as string;
};
